module.exports = __webpack_public_path__ + "static/img/1.25d21fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/1.png
// module id = MOsO
// module chunks = 0